import { I18n } from 'lib/i18n'
import { get, upload } from 'lib/utilities'
import { toast } from 'react-toastify'

const IMPORT_PRODUCTS = 'sync/IMPORT_PRODUCTS'
const IMPORT_PRODUCTS_DONE = 'sync/IMPORT_PRODUCTS_DONE'
const IMPORT_PRODUCTS_FAILED = 'sync/IMPORT_PRODUCTS_FAILED'
const LOAD_PRODUCT_STATE = 'sync/LOAD_PRODUCT_STATE'
const LOAD_PRODUCT_STATE_DONE = 'sync/LOAD_PRODUCT_STATE_DONE'
const LOAD_PRODUCT_STATE_FAILED = 'sync/LOAD_PRODUCT_STATE_FAILED'
const IMPORT_ALL_NEW_PRODUCTS = 'sync/IMPORT_ALL_NEW_PRODUCTS'
const IMPORT_ALL_NEW_PRODUCTS_DONE = 'sync/IMPORT_ALL_NEW_PRODUCTS_DONE'
const IMPORT_ALL_NEW_PRODUCTS_FAILED = 'sync/IMPORT_ALL_NEW_PRODUCTS_FAILED'

const IMPORT_DEALERS = 'sync/IMPORT_DEALERS'
const IMPORT_DEALERS_DONE = 'sync/IMPORT_DEALERS_DONE'
const IMPORT_DEALERS_FAILED = 'sync/IMPORT_DEALERS_FAILED'
const LOAD_DEALER_STATE = 'sync/LOAD_DEALER_STATE'
const LOAD_DEALER_STATE_DONE = 'sync/LOAD_DEALER_STATE_DONE'
const LOAD_DEALER_STATE_FAILED = 'sync/LOAD_DEALER_STATE_FAILED'

const LOAD_STOCK_STATE = 'sync/LOAD_STOCK_STATE'
const LOAD_STOCK_STATE_DONE = 'sync/LOAD_STOCK_STATE_DONE'
const LOAD_STOCK_STATE_FAILED = 'sync/LOAD_STOCK_STATE_FAILED'

export const importProducts = (accepted) => ({
  type: IMPORT_PRODUCTS,
  file: accepted[0],
})
export const importProductsFulfilled = () => ({ type: IMPORT_PRODUCTS_DONE })
export const importProductsFailed = (errors) => ({
  type: IMPORT_PRODUCTS_FAILED,
  errors,
})
export const loadProductState = () => ({ type: LOAD_PRODUCT_STATE })
export const loadProductStateFulfilled = (productState) => ({
  type: LOAD_PRODUCT_STATE_DONE,
  productState,
})
export const loadProductStateFailed = (errors) => ({
  type: LOAD_PRODUCT_STATE_FAILED,
  errors,
})
export const importAllNewProducts = () => ({ type: IMPORT_ALL_NEW_PRODUCTS })
export const importAllNewProductsFulfilled = () => ({
  type: IMPORT_ALL_NEW_PRODUCTS_DONE,
})
export const importAllNewProductsFailed = () => ({
  type: IMPORT_ALL_NEW_PRODUCTS_FAILED,
})

export const importDealers = (accepted) => ({
  type: IMPORT_DEALERS,
  file: accepted[0],
})
export const importDealersFulfilled = () => ({ type: IMPORT_DEALERS_DONE })
export const importDealersFailed = (errors) => ({
  type: IMPORT_DEALERS_FAILED,
  errors,
})
export const loadDealerState = () => ({ type: LOAD_DEALER_STATE })
export const loadDealerStateFulfilled = (dealerState) => ({
  type: LOAD_DEALER_STATE_DONE,
  dealerState,
})
export const loadDealerStateFailed = (errors) => ({
  type: LOAD_DEALER_STATE_FAILED,
  errors,
})

export const loadStockState = () => ({ type: LOAD_STOCK_STATE })
export const loadStockStateFulfilled = (stockState) => ({
  type: LOAD_STOCK_STATE_DONE,
  stockState,
})
export const loadStockStateFailed = (errors) => ({
  type: LOAD_STOCK_STATE_FAILED,
  errors,
})

const initialState = {
  importingProducts: false,
  loadingProductState: false,
  productState: {
    new: [],
    deleted: [],
    updated: [],
    errors: [],
    last_sync: '',
  },
  dealerState: {
    new: [],
    deleted: [],
    updated: [],
    errors: [],
    last_sync: '',
  },
}

export const importReducer = (state = initialState, action) => {
  switch (action.type) {
    case IMPORT_PRODUCTS:
      return { ...state, importingProducts: true }
    case IMPORT_PRODUCTS_DONE:
    case IMPORT_PRODUCTS_FAILED:
      return { ...state, importingProducts: false }
    case LOAD_PRODUCT_STATE:
    case IMPORT_ALL_NEW_PRODUCTS:
      return { ...state, loadingProductState: true }
    case LOAD_PRODUCT_STATE_DONE:
      return {
        ...state,
        loadingProductState: false,
        productState: action.productState,
      }
    case IMPORT_DEALERS:
      return { ...state, importingDealers: true }
    case IMPORT_DEALERS_DONE:
      return { ...state, importingDealers: false }
    case IMPORT_DEALERS_FAILED:
      return { ...state, importingDealers: false }
    case LOAD_DEALER_STATE:
      return { ...state, loadingDealerState: true }
    case LOAD_DEALER_STATE_DONE:
      return {
        ...state,
        loadingDealerState: false,
        dealerState: action.dealerState,
      }
    case LOAD_STOCK_STATE:
      return { ...state, loadingStockState: true }
    case LOAD_STOCK_STATE_DONE:
      return {
        ...state,
        loadingStockState: false,
        stockState: action.stockState,
      }
    default:
      return state
  }
}

export const importProductsEpic = (action$, store) =>
  action$
    .ofType(IMPORT_PRODUCTS)
    .mergeMap((action) => upload('/import_products/import.json', action.file))
    .mergeMap((result) => {
      if (result.ok) {
        toast.success(I18n.t('action.importer/IMPORT_PRODUCTS_DONE'))
        return [importProductsFulfilled(), loadProductState()]
      } else {
        toast.error(I18n.t('action.importer/IMPORT_PRODUCTS_FAILED'))
        return [importProductsFailed(result.body.errors)]
      }
    })

export const loadProductStateEpic = (action$, store) =>
  action$
    .ofType(LOAD_PRODUCT_STATE)
    .mergeMap((action) => get('/import_products/state.json'))
    // .delay(1000)
    .mergeMap((result) => {
      if (result.ok) {
        return [loadProductStateFulfilled(result.body)]
      } else {
        toast.error(I18n.t('action.importer/LOAD_PRODUCT_STATE_FAILED'))
        loadProductStateFailed(result.body && result.body.errors)
      }
    })

export const importDealersEpic = (action$, store) =>
  action$
    .ofType(IMPORT_DEALERS)
    .mergeMap((action) => upload('/import_dealers/import.json', action.file))
    .mergeMap((result) => {
      if (result.ok) {
        toast.success(I18n.t('action.importer/IMPORT_DEALERS_DONE'))
        return [importDealersFulfilled(), loadDealerState()]
      } else {
        toast.error(I18n.t('action.importer/IMPORT_DEALERS_FAILED'))
        return [importDealersFailed(result.body.errors)]
      }
    })

export const loadDealerStateEpic = (action$, store) =>
  action$
    .ofType(LOAD_DEALER_STATE)
    .mergeMap((action) => get('/import_dealers/state.json'))
    .mergeMap((result) => {
      const { body } = result
      if (result.ok) {
        return [loadDealerStateFulfilled(result.body)]
      } else {
        toast.error(I18n.t('action.importer/LOAD_DEALER_STATE_FAILED'))
        return [loadDealerStateFailed(body.errors)]
      }
    })

export const loadStockStateEpic = (action$, store) =>
  action$
    .ofType(LOAD_STOCK_STATE)
    .mergeMap((action) => get('/product/stock_state.json'))
    .mergeMap((result) => {
      if (result.ok) {
        return [loadStockStateFulfilled(result.body)]
      } else {
        toast.error(I18n.t('action.importer/LOAD_STOCK_STATE_FAILED'))
        return [loadStockStateFailed(result.body.errors)]
      }
    })



// WEBPACK FOOTER //
// ./src/redux/importer.js